import { all, fork } from "redux-saga/effects";

import { authSaga } from "../app/modules/Auth/_redux/authRedux";

export function* rootSaga() {
  yield all([
    // Auth
    fork(authSaga),
    // Catalog
    // Catalog -> brands
    // fork(brandSaga),
  ]);
}
